import { Injectable } from '@angular/core';
import { createUserWithEmailAndPassword, getAuth, sendEmailVerification, sendPasswordResetEmail, signOut, updateProfile } from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  async signUp(name: string, email: string, password: string): Promise<void> {
    const auth = getAuth();
    const normalizedEmail = email.trim().toLowerCase();
    const credential = await createUserWithEmailAndPassword(auth, normalizedEmail, password);
    await updateProfile(credential.user, { displayName: name.trim() });
    await sendEmailVerification(credential.user);
    await signOut(auth);
  }

  async resetPassword(email: string): Promise<void> {
    const auth = getAuth();
    auth.useDeviceLanguage();
    await sendPasswordResetEmail(auth, email.trim());
  }
}
